import { call, put, takeLatest } from 'redux-saga/effects';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';
import axios from 'axios';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import {
  REQUEST, fetchResponse, fetchFailure,
} from '../../actions/settings/public';

function* fetch() {
  try {
    const response = yield call(
      axios.get,
      `${config.API_URL}/settings/public`,
      { headers: getLocalUser() },
    );
    const payload = response.data?.data ?? response.data ?? {};
    yield put(fetchResponse(payload));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, fetch);
}
